import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import 'katex/dist/katex.min.css';
import './QuestionBubble.css';

// Extend the default schema with custom allowed tags
const customSchema = {
  ...defaultSchema,
  tagNames: [
    ...(defaultSchema.tagNames || []),
    'u',
    'sub',
    'sup',
    'br',
    'span',
  ],
  attributes: {
    ...defaultSchema.attributes,
    u: [],      // allow <u>
    sub: [],    // allow <sub>
    sup: [],    // allow <sup>
    br: [],     // allow <br>
    span: ['className'], // allow spans with classes
  },
};

const QuestionBubble = ({ question, graphicUrl }) => {
  // Preprocess: replace backtick-wrapped math with dollar signs
  const processedQuestion = question
    // Inline math: `x^2` → $x^2$
    .replace(/`([^`]+)`/g, (_match, p1) => `$${p1}$`)
    // Optional: handle multiline block math wrapped in triple backticks ```math``` → $$...$$
    .replace(/```(?:math)?\s*([\s\S]*?)```/g, (_match, p1) => `$$${p1}$$`);

  return (
    <div className="question-bubble">
      {graphicUrl && (
        <div className="question-graphic-container">
          <img src={graphicUrl} className="question-graphic" alt="graphic" />
        </div>
      )}
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[
          rehypeRaw,
          [rehypeSanitize, customSchema],
          rehypeKatex,
        ]}
        className="markdown-content"
      >
        {processedQuestion}
      </ReactMarkdown>
    </div>
  );
};
export default QuestionBubble;